import { Button, Modal } from "semantic-ui-react";
import { deleteTable } from "../../../services/tablesService";
import { toast } from "../../..";
import { ITableDto } from "../../../models/table";
import { useState } from "react";

interface IProps {
    deleteTableModalOpen: boolean;
    closeDeleteTableModal: () => void;
    tableToDelete: ITableDto;
    handleClearFilter: () => void;
    refreshTables: () => void;
}

export const DeleteTableModal = ({
    deleteTableModalOpen,
    closeDeleteTableModal,
    tableToDelete,
    refreshTables,
    handleClearFilter,
}: IProps) => {
    const [loading, setLoading] = useState(false);
    const handleDeleteTable = async () => {
        setLoading(true);
        try {
            await deleteTable(tableToDelete.guid);
            handleClearFilter();
            toast("Table deleted successfully", true, 2000);
            refreshTables();
        } catch {
            toast("Error deleting table", false, 2000);
        } finally {
            setLoading(false);
            closeDeleteTableModal();
        }
    };

    return (
        <Modal open={deleteTableModalOpen} onClose={closeDeleteTableModal}>
            <Modal.Header>Delete table</Modal.Header>
            <Modal.Content>
                Are you sure you want to delete table {tableToDelete.name}?
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={closeDeleteTableModal} content="Cancel" loading={loading} />
                <Button primary onClick={handleDeleteTable} content="Delete" loading={loading} />
            </Modal.Actions>
        </Modal>
    );
};
